import { Navigate } from 'react-router';
import { HeaderImgStyled } from '../../../components';
import { useSessionStorage } from '../../../hooks';
import { LoginStyled, LoginHeaderStyled, LoginContentStyled } from './styled';

export const AuthLogin = () => {
  const [authenticated, setAuthenticated] = useSessionStorage('authenticated');

  if (!authenticated)
    return (
      <LoginStyled>
        <LoginHeaderStyled>
          <HeaderImgStyled />
        </LoginHeaderStyled>
        <LoginContentStyled>
          <div
            style={{
              marginBottom: '8px',
              display: 'flex',
              justifyContent: 'start'
            }}>
            <label>User Name</label>&nbsp;
            <input type='text' id='username' />
          </div>
          <div
            style={{
              marginBottom: '8px',
              display: 'flex',
              justifyContent: 'end'
            }}>
            <label>Password</label>&nbsp;&nbsp;&nbsp;
            <input type='text' id='password' />
          </div>
          <button
            onClick={() => {
              //call api to authenticate
              setAuthenticated(true);
            }}>
            Login
          </button>
        </LoginContentStyled>
      </LoginStyled>
    );
  return <Navigate to='/auth/callback' replace />;
};
